/* eslint-disable max-len */
import Vue from 'vue'
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
import template from './_new-search-directions-form.pug'
import SearchDirectionService from 'js/services/api/search-direction/search-direction'
import StopsService from 'js/services/api/topology/stops'
import SearchPointsOfInterest from 'js/services/api/search-direction/search-points-of-interest'
import { cancelGeocoderSearches } from 'js/services/api/search-direction/geocoder-ranked-search'
import ModalSelectTransport from 'js/pages/planner/direction-internal-result/components-planner/modal-select-transports/_modal-select-transport';
import ModalSelectOperator from 'js/pages/planner/direction-internal-result/components-planner/modal-select-operators/_modal-select-operator';
import clickOutside from 'js/directives/v-click-outside';
import {
  getAllowedPlannerTransports,
  shouldShowPlannerOperatorFilter,
  shouldShowPlannerTransportFilter
} from 'js/config/planner'
import {
  areAllAllowedTransportsSelected,
  buildPlannerMasterOperatorsUpdate,
  buildPlannerOperatorOptions,
  buildPlannerTransportOptions,
  buildTransportModeCalls,
  generatePlannerModeCalls,
  getInitialSelectedTransports,
  initializeSelectedPlannerOperators,
  resetPlannerOperators
} from 'js/lib/planner/search-form'
import {
  GEOCODER_MIN_QUERY_LENGTH,
  GEOCODER_SEARCH_DEBOUNCE_MS,
  buildDropdownSections,
  buildRecentSearches,
  buildSearchDirectionsParams,
  buildSearchDirectionResults,
  countConsecutiveMatches,
  dedupeLocations,
  extractPointOfInterestResults,
  filterCustomStops,
  getFinalLocationName,
  getPointOfInterestIconClass,
  getSearchDirectionState,
  getMunicipalityBoundsCorners,
  removeFunctionalInterceptors
} from 'js/lib/planner/search-location'
import {
  buildPlannerTimeModes,
  buildPlannerTimeOptions,
  buildSelectedPlannerTimeLabel,
  getPlannerSelectedTimeValue,
  getSelectedPlannerTimeText,
  getSelectedPlannerTimeModeText,
  isPlannerButtonDisabled,
  isPlannerDateInvalid
} from 'js/lib/planner/search-time'
import {
  buildGooglePlaceDirectionUpdate,
  buildSelectedLocationUpdate,
  formatPlannerCoordinates,
  getEffectivePlannerPosition,
  swapPlannerDirections
} from 'js/lib/planner/search-selection'
import {
  buildPlannerStoreCommitEntries,
  buildPlannerSubmitData
} from 'js/lib/planner/search-submit'
import { buildPlannerStoreRecovery } from 'js/lib/planner/search-recovery'
import {
  buildPlannerMapSelectionState,
  buildPlannerMapStatus,
  buildPlannerResetPointsState,
  buildSearchDirectionOnMapUpdate
} from 'js/lib/planner/search-map-state'

import {
  VALID_ICONS,
  MODE_DIRECTION,
  MODE_COORDINATES,
  LIMIT_SEARCH, ORIGIN,
  TIME_FORMAT,
  TRANSPORT_OPTIONS,
  PUBLIC_TRANSPORT_MODE,
  PRIVATE_TRANSPORT_MODE,
  TIME_OPTIONS,
  PHOTON,
  GOOGLE,
  OPTIONS_tRANSPORT,
  DATETIME_FORMAT,
  DATE_FORMAT,
  WALKING
} from './Constant/constans.js'



export default Vue.extend({
	name: 'new-search-directions-form',
	template: template(),

	directives: {
    clickOutside
  },

	components: {
		ModalSelectTransport,
    ModalSelectOperator
	},
	
	props: {
		stops: {
      type: Array,
      default: []
    },
    operators: {
      type: Array,
      default: []
    },
    favoritesStops: {
      type: Array,
      default: []
    },
    noRoutesAvailable: {
      type: Boolean,
      default: false
    },

    showErrorMessage: {
      type: String,
      default: ''
    },
    searchDirectionOnMap: {
      type: Object,
      default: () => ({})
    },
    isMurcia: {
      type: Boolean,
      required: true, 
      default: false
    },
    isGc: {
      type: Boolean,
      required: true,
      default: false
    }
	},
  data() {
    return {
      // Este valor llega desde admin, por zona administrativa pero no esta operativo
      enablePlannerWithMap: true ,
			locations:[],
			filteredCustomStops: [],
      filterdCustomStopsfavorites: [],
			// Datos del origen
			originMode: MODE_DIRECTION,
			originDirection: undefined,
			// Datos del destino
			destinationMode: MODE_DIRECTION,
			destinationDirection: undefined,
			recentSearchesOrigin: [],  // Búsquedas recientes para el campo "origen"
			recentSearchesDestination: [],  // Búsquedas recientes para el campo "destino"
			pointsOfInterest:[],
			// Indica si es origin o destination
			currentWaypoints: '',
			//Loading msg
			isLoadingOrigin: false,
			isLoadingDestination: false,
			activeField: ORIGIN, // Campo activo, por defecto 'origin' 
			showLocations: false,
			isSelecting: false,
			isSelectingFromMap: false,
			activePointsMap: false,
			validIcons : VALID_ICONS,
			showTransportModal: false,
      showOperatortModal : false,
      selectedTransports: {
        BUS: true,
        SUBWAY: true,
        RAIL: true,
        BICYCLE_RENT: true,
        TAXI: true,
        BICYCLE: true,
        CAR: true,
        MOTORCYCLE: true,
        WALK: true,
      },
      selectedOperatos: {},
      OPERATOR_OPTIONS: [],
      selectedOperators: this.initializeSelectedOperators(),
      transportOperatorMap: {
        BUS: ['METROBUS', 'EMT', 'Metrobus'],
        SUBWAY: ['METROVALENCIA','Metro Valencia', 'Metro-Valencia','MetroValencia'],
        RAIL: ['RENFECERCANIAS', 'Renfe Cercanias', 'RENFE-Cercanias','RENFE-Cercanias QA'],
        BICYCLE_RENT: ['VALENBISI', 'Valenbisi'],
      },
      masterOperatorsList: [], //MASTER LIST: It will store all seen operators.
      isListTime: false,
      // No walking time selected: the placeholder is shown and OTP gets maxWalkDistance=5000
      selectedTime: null,
      // Modo de tiempo
      timeMode: undefined,
      timeModeHour: undefined,
      timeModeDate: undefined,
      selectedTimeValue: undefined,
      isTimeModeList: false,
      favorite: [],
      selectedTransportsInitialized: false,
		}
	},

	mounted() {
    this.initMapsSearchBoxes()
    this.loadRecentSearches()
    // this.selectedTime = this.$store.state.planner.plannerSelectedTime;
  },

	async created() {
		this.searchDirections = debounce(this.searchDirections, GEOCODER_SEARCH_DEBOUNCE_MS);
		this.recoverStorePlannerData()

    if (this.$store.state.currentUser) {
      this.favorite = await this.searchFavorite()
    }
	},

	computed: {
    ...mapGetters('appConfig', [
          'planner_router_url',
          'planner_router_reverse_url'
        ]),
		...mapGetters([
      'userPosition'
    ]),

		filteredLocations() {
      return this.locations;
    },
    // Lists rendered by the dropdown, deduplicated across sections (COEGIS1-15259)
    originSections() {
      return buildDropdownSections({
        locations: this.locations,
        recentSearches: this.recentSearchesOrigin,
        customStops: this.filteredCustomStops,
        pointsOfInterest: this.pointsOfInterest,
        searchTerm: this.originDirection
      })
    },
    destinationSections() {
      return buildDropdownSections({
        locations: this.locations,
        recentSearches: this.recentSearchesDestination,
        customStops: this.filteredCustomStops,
        pointsOfInterest: this.pointsOfInterest,
        searchTerm: this.destinationDirection
      })
    },
    effectivePlannerPosition() {
      return getEffectivePlannerPosition(
        this.userPosition,
        this.currentMunicipality?.geo,
        this.currentAppConfig?.geo
      )
    },
		loadingMsg() {
      const dots = '.'.repeat(this.dotCount);
      return this.$t('planner.loading') + dots
    },
		isOrigin() {
      return this.currentWaypoints === "origin";
    },
		origin() {
      if (this.originModeCoordinatesAvailable) {
        return `${this.userPosition.lat}, ${this.userPosition.lng}`
      }
      return this.originDirection
    },
    filteredLocationsUserPosition() {
      // Agrega "Mi ubicación" al inicio de las opciones disponibles
      return {name: this.$t('planner.myPosition'), coordinates: this.effectivePlannerPosition}
    },
    municipalityBounds() {
      const municipality = this.currentMunicipality

      if (!municipality || !municipality.geo) return null

      const {southWest, northEast} = getMunicipalityBoundsCorners({
        upperLeft: {lat: municipality.upper_left_bound_lat, lng: municipality.upper_left_bound_lng},
        lowerRight: {lat: municipality.lower_right_bound_lat, lng: municipality.lower_right_bound_lng},
        municipalityCenter: municipality.geo
      })

      return new google.maps.LatLngBounds(
        new google.maps.LatLng(southWest.lat, southWest.lng),
        new google.maps.LatLng(northEast.lat, northEast.lng)
      )
    },
		destinationModeCoordinatesAvailable() {
      return this.userPosition && this.destinationMode === MODE_COORDINATES
    },
		destinationModeCoordinatesAvailable(newValue) {
      if (!newValue) {
        this.destinationMode = MODE_DIRECTION
      }
    },
		destination() {
      if (this.destinationModeCoordinatesAvailable) {
        return `${this.userPosition.lat}, ${this.userPosition.lng}`
      }
      return this.destinationDirection
    },

		selectedTransportLabelText() {
      // Comprueba si alguna opción está seleccionada
      const hasSelectedOptions = Object.values(this.selectedTransports).some(value => value);

  
      // Si no hay opciones seleccionadas, devuelve "Todos"
      if (!hasSelectedOptions || this.isAllSelected) {
        return this.$t('planner.transports.ALL');
      }

      // Si hay opciones seleccionadas, devuelve "Seleccione uno o varios"
      return this.$t('planner.transports.selectMultiple');
    },

    selectedOperatorsLabelText() {
      const hasSelectedOptions = Object.values(this.selectedOperators).some(value => value);
      // Si no hay opciones seleccionadas, devuelve "Todos"
      if (!hasSelectedOptions ) {
        return this.$t('planner.operators.operator');
      }
      return this.$t('planner.operators.varios')
    },

    hasSelectedTransport() {
      // Devuelve true si alguno de los valores es true
      return Object.values(this.selectedTransports).includes(true);
    },

    hasSelectedOperator() {
      // Devuelve true si alguno de los valores es true
      return Object.values(this.selectedOperators).includes(true);
    },

    showTransportFilter() {
      return shouldShowPlannerTransportFilter(this.currentAppConfig?.code)
    },

    showOperatorFilter() {
      return shouldShowPlannerOperatorFilter(this.currentAppConfig?.code)
    },


    selectedTransportsInit() {
      return getInitialSelectedTransports(this.currentAppConfig.code)
    },

     isAllSelected() {
      return areAllAllowedTransportsSelected(this.currentAppConfig.code, this.selectedTransports)
    },

    // Opciones dinámicas de transporte
    /**
     * Genera una lista de opciones de transporte con las traducciones actuales,
     * utilizando las claves definidas en `labelKey`.
     *
     * @returns {Array} Opciones de transporte traducidas dinámicamente.
     */
    transportOptions() {
      return buildPlannerTransportOptions(TRANSPORT_OPTIONS, this.currentAppConfig.code, key => this.$t(key))
    },

    operatorOptions() {
      return buildPlannerOperatorOptions(this.masterOperatorsList, this.selectedOperators)
    },

    getSelectedTimeText() {
      if (this.selectedTimeValue !== undefined) {
        return buildSelectedPlannerTimeLabel(this.selectedTimeValue, key => this.$t(key))
      }

      return getSelectedPlannerTimeText(this.selectedTime, key => this.$t(key));
    },

    // Tipo de modos de tiempo para la consulta
    timeOptions() {
      return buildPlannerTimeOptions(TIME_OPTIONS, key => this.$t(key))
    },

    timeModes() {
      return buildPlannerTimeModes(key => this.$t(key))
    },

    timeOptions() {
      return buildPlannerTimeOptions(TIME_OPTIONS, key => this.$t(key))
    },

        // Opciones de tránsito que se van a mandar a la API de google
    // https://developers.google.com/maps/documentation/javascript/directions#TransitOptions
    // {
    //   arrivalTime: Date, <- Si se especifica se ignora departureTime
    //   departureTime: Date, <- Por defecto a now si no se indica
    // }
    transitOptions() {
      if (this.timeMode === 'now') {
        return {}
      }
      const time = moment(`${this.timeModeDate} ${this.timeModeHour}`, DATETIME_FORMAT)
      const date = time.toDate()

      if (this.timeMode === 'departure') {
        return { departureTime: date }
      }
      return { arrivalTime: date }
    },

    // Deshabilita o no el botón de llamar al planificador de Google
    plannerButtonDisabled() {
      return isPlannerButtonDisabled(this.origin, this.destination, this.timeMode, this.invalidDate)
    },

    // Comprueba si la fecha de inicio o llegada es inválida
    invalidDate() {
      return isPlannerDateInvalid(this.timeModeDate, this.timeModeHour)
    },

    getSelectedTimeModeText() {
      return getSelectedPlannerTimeModeText(this.timeModes, this.timeMode, key => this.$t(key))
    },

    timeModeDateConfig() {
      const currentLocale = Vue.i18n.locale;
      const calendarLocales = Vue.i18n.locales || {};

      return {
        allowInput: true,

        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y', 

        onChange: (dates, dateStr) => {
          this.timeModeDate = dateStr;
        },

        disableMobile: true,
        locale: calendarLocales[currentLocale] || 'default'
      }
    },
  },

  watch: {
    operatorOptions : {
      handler( newValue ) {
        if (newValue && newValue.length > 0) {
          this.OPERATOR_OPTIONS = this.operatorOptions
        }
      },
      immediate: true
    },

    selectedTransports: {
      deep: true,
      handler() {
        const allowed = getAllowedPlannerTransports(this.currentAppConfig?.code);
        if (allowed) {
          Object.keys(this.selectedTransports).forEach(transport => {
            if (!allowed.includes(transport) && this.selectedTransports[transport]) {
              this.$set(this.selectedTransports, transport, false);
            }
          });
        }

        // Ignore the first trigger on mount
        if (!this.selectedTransportsInitialized) {
          this.selectedTransportsInitialized = true;
          return;
        }
        // Cada vez que cambie selectedTransports, reseteamos selectedOperators a false
        this.resetOperators();
      }
    },

    selectedOperators: {
      deep: true,
      handler(newValue) {
        this.$store.commit('setPlannerSelectedOperators', {...newValue})
      }
    },

    operators: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.updateMasterOperators(newValue);
        }
      },
      immediate: true
    },
    searchDirectionOnMap: {
      handler( newValue ) {
        this.resetPoints()
        const mapDirectionUpdate = buildSearchDirectionOnMapUpdate(newValue)

        Object.keys(mapDirectionUpdate).forEach(key => {
          this[key] = mapDirectionUpdate[key]
        })
      },
      deep: true, //observar cambios profundos en el objeto
      immediate: true // Si quieres que el handler se ejecute inmediatamente con el valor actual
    }
  },

	beforeDestroy() {
		this.cancelPendingSearch()
	},

  methods: {
    /**
         * Updates the master list of operators by merging new operators with existing ones.
         * @param {Array} newOperators - List of operators arriving from the map/service (the 'operators' prop).
         */
    updateMasterOperators(newOperators) {
      const nextOperatorState = buildPlannerMasterOperatorsUpdate(
        this.masterOperatorsList,
        newOperators,
        this.selectedOperators,
        this.$store.getters.getPlannerSelectedOperators || {}
      )

      if (!nextOperatorState) {
        return;
      }

      Object.keys(nextOperatorState.selectedOperatorUpdates).forEach(operatorName => {
        this.$set(
          this.selectedOperators,
          operatorName,
          nextOperatorState.selectedOperatorUpdates[operatorName]
        );
      })

      this.masterOperatorsList = nextOperatorState.masterOperatorsList;
    },

		originInMAp( waypoints ) {
      // Comprobar si el currentWaypoints es el mismo que se ha clicado
      const nextMapState = buildPlannerMapSelectionState(this.currentWaypoints, waypoints)

      if (nextMapState.shouldReset) {
        this.resetPoints()
        return; // Salir de la función sin hacer nada más
      }

      Object.keys(nextMapState.updates).forEach(key => {
        this[key] = nextMapState.updates[key]
      })
      
      this.emitMapStatus();
      this.deactivateOppositeField();
    },

    goToPlanner() {

      const transportModeCalls = this.getTransportModesByCategory(); // Obtenemos las combinaciones
      const { originDirection, destinationDirection } = this; // Extraemos estas variables como antes
      const selectedTimeText = this.getSelectedTimeText

      const plannerData = buildPlannerSubmitData({
        transitOptions: this.transitOptions,
        originCoordinates: this.originCoordinates,
        destinationCoordinates: this.destinationCoordinates,
        administrativeAreaTimeZone: this.$administrativeAreaTimeZone,
        otpUrl: this.currentAppConfig.planner_motor_url,
        originDirection,
        destinationDirection,
        selectedTransports: this.selectedTransports,
        selectedOperators: this.selectedOperators,
        operatorOptions: this.operatorOptions,
        selectedTime: selectedTimeText,
        transportModeCalls
      });

      // Actualizar el estado en el store
      buildPlannerStoreCommitEntries({
        origin: this.origin,
        destination: this.destination,
        originCoordinates: this.originCoordinates,
        destinationCoordinates: this.destinationCoordinates,
        selectedTransports: this.selectedTransports,
        timeMode: this.timeMode,
        timeModeHour: this.timeModeHour,
        timeModeDate: this.timeModeDate,
        googleRoutesResponse: this.googleRoutesResponse,
        selectedTime: selectedTimeText,
        selectedOperators: this.selectedOperators
      }).forEach(([mutation, value]) => {
        this.$store.commit(mutation, value);
      })

      this.$emit('goToPlanner', plannerData);
    },

    getTransportModesByCategory() {
      return buildTransportModeCalls(this.selectedTransports, OPTIONS_tRANSPORT)
    },

		searchDirections() {
      this.resetPoints();
      const searchState = getSearchDirectionState(
        this.activeField,
        this.originDirection,
        this.destinationDirection
      )
      const searchTerm = searchState.searchTerm || ''
      const normalizedSearchTerm = searchTerm.trim()

      if (!normalizedSearchTerm) {
        cancelGeocoderSearches()
        this[searchState.directionField] = ''
        this.locations = []
        this.filteredCustomStops = []
        this.pointsOfInterest = []
        this.isLoadingOrigin = false
        this.isLoadingDestination = false
        this.showLocations = true

        return
      }

      // Too short to be worth a Photon request: clear the results instead.
      if (normalizedSearchTerm.length < GEOCODER_MIN_QUERY_LENGTH) {
        cancelGeocoderSearches()
        this.locations = []
        this.filteredCustomStops = []
        this.pointsOfInterest = []
        this.isLoadingOrigin = false
        this.isLoadingDestination = false
        this.showLocations = true

        return
      }

			this[searchState.loadingField] = true;

			this.filteredCustomStops = this.filteredCustomStopsMethod( normalizedSearchTerm, 'stops' );

			const { municipalityBounds } = this;

      const searchTermWithCity = municipalityBounds ? normalizedSearchTerm : (normalizedSearchTerm + ' ' + (this.currentMunicipality ? this.currentMunicipality.name : ''));
      const paramsBuscar = buildSearchDirectionsParams(
        searchTermWithCity,
        this.currentAppConfig.planner_router_url,
        municipalityBounds,
        LIMIT_SEARCH,
        this.currentMunicipality ? this.currentMunicipality.geo.lat : null,
        this.currentMunicipality ? this.currentMunicipality.geo.lng : null,
        this.userPosition
      )

      // Guarda la referencia del interceptor, header
      const myInterceptor = removeFunctionalInterceptors(Vue.http.interceptors)

			this.buscarpuntosInteres(paramsBuscar, true, { skipLoading:true }).then(response => {
        if ((this[searchState.directionField] || '').trim() !== normalizedSearchTerm) return
        try {
          this.pointsOfInterest = this.extractValueAndName(response);
          this.pointsOfInterest = dedupeLocations(this.pointsOfInterest, this.locations);
        } catch (error) {
          // Manejar errores
        }
      }).catch(() => {
        if ((this[searchState.directionField] || '').trim() !== normalizedSearchTerm) return
        this.pointsOfInterest = []
      })

			this.buscar(paramsBuscar, true, { skipLoading:true }).then(response => {
        if ((this[searchState.directionField] || '').trim() !== normalizedSearchTerm) return
        this.isLoadingOrigin = false;
        this.isLoadingDestination = false;
        // Procesamos la respuesta y actualizamos locations
        this.locations = this.processResponse(response);
        this.pointsOfInterest = dedupeLocations(this.pointsOfInterest, this.locations);
        this.showLocations = true; // Muestra el contenedor de resultados
      }).catch(() => {
        // Manejar errores
        if ((this[searchState.directionField] || '').trim() !== normalizedSearchTerm) return
        this.isLoadingOrigin = false
        this.isLoadingDestination = false
        this.locations = []
      })
			// Agregar el interceptor nuevamente
			Vue.http.interceptors.push(...myInterceptor)

		},

		// Drops the scheduled debounced search and aborts the in-flight Photon requests.
		cancelPendingSearch() {
      if (this.searchDirections && typeof this.searchDirections.cancel === 'function') {
        this.searchDirections.cancel()
      }
      cancelGeocoderSearches()
      if (typeof this.stopLoading === 'function') {
        this.stopLoading()
      } else {
        this.isLoadingOrigin = false
        this.isLoadingDestination = false
      }
    },

		filteredCustomStopsMethod(searchTerm) {
      return filterCustomStops(this.stops, searchTerm, LIMIT_SEARCH)
    },

		// Función para contar coincidencias consecutivas
		countConsecutiveMatches(searchTerm, stopName) {
			return countConsecutiveMatches(searchTerm, stopName)
		},

		// Servicio que se encarga de buscar los puntos de interes
		async buscarpuntosInteres(params) {
			try {
				const response = SearchPointsOfInterest.get(params, true)
				// Devolver lista de puntos de interes
				return response
			} catch (error) {
				// Devolver una promesa rechazada en caso de error
				return Promise.reject(error)
			}
		},

		async buscar(params) {
      try {
        const response = SearchDirectionService.get(params, true)
        // Devolver lista de features encontradas en Photon
        return response
      } catch (error) {
        // Devolver una promesa rechazada en caso de error
        return Promise.reject(error)
      }
    },

		processResponse(response) {
      return buildSearchDirectionResults(response, LIMIT_SEARCH)
    },

		// Oculta el menú desplegable
		closeLocations() {
      this.showLocations = false; 
    },

		closeOriginLocations() {
      if (this.activeField === ORIGIN) {
        this.closeLocations()
      }
    },

		closeDestinationLocations() {
      if (this.activeField === 'destination') {
        this.closeLocations()
      }
    },

		loadRecentSearches() {
      // Cargar las búsquedas recientes de origen y destino desde LocalStorage
      this.recentSearchesOrigin = JSON.parse(localStorage.getItem('recentSearchesOrigin')) || [];
      this.recentSearchesDestination = JSON.parse(localStorage.getItem('recentSearchesDestination')) || [];
    },

		storeRecentSearch(location, fieldType) {
      let searchList;
    
      if (fieldType === 'origin') {
        searchList = this.recentSearchesOrigin;
      } else if (fieldType === 'destination') {
        searchList = this.recentSearchesDestination;
      }
      searchList = buildRecentSearches(searchList, location, LIMIT_SEARCH)
    
      // Guardar en localStorage según el campo
      if (fieldType === 'origin') {
        this.recentSearchesOrigin = searchList;
        localStorage.setItem('recentSearchesOrigin', JSON.stringify(searchList));
      } else if (fieldType === 'destination') {
        this.recentSearchesDestination = searchList;
        localStorage.setItem('recentSearchesDestination', JSON.stringify(searchList));
      }
    },

		extractValueAndName(response) {
      return extractPointOfInterestResults(response, LIMIT_SEARCH)
    },

    getFinalName(properties) {
      return getFinalLocationName(properties)
    },

		getIconClass(properties) {
      return getPointOfInterestIconClass(properties, this.validIcons)
    },

		changeValues() {
      const nextDirections = swapPlannerDirections({
        originDirection: this.originDirection,
        destinationDirection: this.destinationDirection,
        originCoordinates: this.originCoordinates,
        destinationCoordinates: this.destinationCoordinates,
        originMode: this.originMode,
        destinationMode: this.destinationMode
      }, MODE_COORDINATES)

      Object.keys(nextDirections).forEach(key => {
        this[key] = nextDirections[key]
      })
    },

		initMapsSearchBoxes() {
      const { municipalityBounds } = this

      const origin = document.getElementById('originDirection')
      const originInput = origin.getElementsByTagName('input')[0]
      const destination = document.getElementById('destinationDirection')
      const destinationInput = destination.getElementsByTagName('input')[0]

      this.planner_router = this.currentAppConfig.planner_router
      if (this.planner_router === GOOGLE || this.planner_router === undefined) {
        // Direccionador de Google
        const searchBoxOrigin = new google.maps.places.Autocomplete(originInput, {
          bounds: municipalityBounds,
          fields: ['name', 'formatted_address', 'geometry']
        })

        const searchBoxDestination = new google.maps.places.Autocomplete(destinationInput, {
          bounds: municipalityBounds,
          fields: ['name', 'formatted_address', 'geometry']
        })

        searchBoxOrigin.addListener('place_changed', this.debounce(() => {
          const place = searchBoxOrigin.getPlace() // Obtener el lugar seleccionado

          if (place) {
            // Establecer datos de la dirección en el input
            this.setDirection('originDirection', place)
          }
        }, this.time_delay))

        searchBoxDestination.addListener('place_changed', this.debounce(() => {
          const place = searchBoxDestination.getPlace() // Obtener el lugar seleccionado

          if (place) {
            // Establecer datos de la dirección en el input
            this.setDirection('destinationDirection', place)
          }
        }, this.time_delay))
      } else if (this.planner_router === PHOTON) {
        // Direccionador de Photon
        // this.createSearchBoxPhoton(originInput)
        // this.createSearchBoxPhoton(destinationInput)
      } else {
        // Estado no posible - PLANNER_MOTOR_ERROR
      }
    },

		setDirection(fieldName, place) {
      const directionUpdate = buildGooglePlaceDirectionUpdate(fieldName, place)

      this[directionUpdate.directionField] = directionUpdate.direction
      this[directionUpdate.coordinatesField] = directionUpdate.coordinates
    },

		/*
		* Inicializa los selectores de posiciones
		*/
		debounce(func, wait, immediate) {
			var timeout;
			return function () {
				var context = this, args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},

		// Recupera datos del planner de la store o asigna valores por defecto
		recoverStorePlannerData() {
			const date = moment()
			const recovery = buildPlannerStoreRecovery(this.$store.getters, {
        timeModeHour: date.format(TIME_FORMAT),
        timeModeDate: date.format(DATE_FORMAT),
        selectedTransports: this.selectedTransportsInit,
        selectedTime: null
      })

      Object.keys(recovery.updates).forEach(key => {
        this[key] = recovery.updates[key]
      })

      this.selectedTimeValue = getPlannerSelectedTimeValue(this.selectedTime, TIME_OPTIONS)

      if (recovery.shouldScroll) {
        this.$nextTick(() => {
          this.scroll()
        })
      }

		},

		handleFocus( directionField ) {
      this.activeField = directionField;
      const searchTerm = (directionField === ORIGIN ? this.originDirection : this.destinationDirection) || ''

      if (!searchTerm.trim()) {
        this.locations = [];
        this.filteredCustomStops = [];
        this.pointsOfInterest = [];
      }
      this.isSelecting = false;
      this.showLocations = true;
      this.resetPoints();
    },

		shouldShowLocationDropdown(field) {
      return this.showLocations
        && this.activeField === field
        && this.isSelectingFromMap === false;
    },

    selectLocation(location) {
      const locationUpdate = buildSelectedLocationUpdate(
        location,
        this.activeField,
        this.$t('planner.myPosition'),
        location.coordinates || this.effectivePlannerPosition
      )

      this[locationUpdate.directionField] = locationUpdate.direction;
      this[locationUpdate.coordinatesField] = locationUpdate.coordinates;
      this.storeRecentSearch(location, locationUpdate.recentSearchFieldType);

      this.showLocations = false; // Ocultar lista de opciones
      this.isSelecting = true; // Evitar otra búsqueda automática
      this.cancelPendingSearch();
    },

    applyOperatorSelection() {
      this.showOperatortModal = false;
      this.applyOperatorSelection = selectedOperators;
    },

    applyTransportSelection() {
      // Aplica la selección y cierra el modal
      this.selectedTransports = selectedTransports;
      this.closeTransportModal();
    },

		openTransportModal() {
      this.showTransportModal = true;
    },

		closeTransportModal() {
      this.showTransportModal = false;
    },

    deselectTransport(value) {
      this.$set(this.selectedTransports, value, false);
    },

    openOperatorsModal() {
      this.showOperatortModal = true;
    },
    
    closeOperatorsModal() {
      this.showOperatortModal = false;
    },

    deselectOperator(value) {
      this.$set(this.selectedOperators, value, false);
    },

    resetOperators() {
      const nextSelectedOperators = resetPlannerOperators(
        this.selectedTransports,
        this.selectedOperators,
        this.transportOperatorMap
      )

      Object.keys(nextSelectedOperators).forEach(operatorKey => {
        this.$set(this.selectedOperators, operatorKey, nextSelectedOperators[operatorKey])
      })
    },

    normalizeNameOperator(name) {
      return name.replace(/-/g, '').toUpperCase();
    },

    selectTime(time) {      
      this.selectedTimeValue = time;
      this.selectedTime = time;
      // Actualiza el valor del tiempo seleccionado
      this.isListTime = false;  // Cierra el desplegable
    },

    toogleListTime () {
      this.isListTime = !this.isListTime;
    },

    toggleTimeModeList() {
      this.isTimeModeList = !this.isTimeModeList;
    },
    selectTimeMode(value) {
      this.timeMode = value;
      this.isTimeModeList = false;
    },

    generateCalls( selectedPublicTransport, isBicycleRentSelected, selectedPrivateTransport, selectedPrivateBicycle ) {
      return generatePlannerModeCalls(
        selectedPublicTransport,
        isBicycleRentSelected,
        selectedPrivateTransport,
        selectedPrivateBicycle
      )
    },

    initializeSelectedOperators() {
      // Try to retrieve previous values from the store
      const savedOperators = this.$store.getters.getPlannerSelectedOperators || {};

      return initializeSelectedPlannerOperators(this.operators, savedOperators)
    },

    deactivateOppositeField() {
      //this.currentWaypoints = '';
    },
  
    emitMapStatus() {
      const mapStatus = buildPlannerMapStatus(this.activePointsMap, this.currentWaypoints);
      this.$emit('mapStatus', mapStatus);
    },

    resetPoints() {
      const resetState = buildPlannerResetPointsState()

      Object.keys(resetState).forEach(key => {
        this[key] = resetState[key]
      })

      this.emitMapStatus();
    },

    convertCoordinatesToString(coordinate) {
      return formatPlannerCoordinates(coordinate)
    },
  
    searchFavorite(){
      let promise

      const stopsParams = {
        municipality_id: this.currentMunicipality.id,
        order_by: "code",
        order_dir: "asc",
        per: 0,
        template: "complete",
      };
      promise = StopsService.favorites(stopsParams);
      return promise
    }

	}
})
